import { Suspense, useContext, useEffect, useState } from "react";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import LoadingView from "../components/LoadingView";
import { AuthContextProvider } from "../context/AuthContext";
import { ScrollContextProvider } from "../context/ScrollContext";
import RouterContext from "./RouterContext";
import layouts from "./layouts";
import RouterList from "./router";

const findRouteConfig = (currentPath = "") => {
  let target: any = RouterList.find((route) => {
    return route.path === currentPath ? window.location.pathname : null;
  });
  if (!target) return "default";

  return !!target ? target : {}; //background
};

function withRouter(Component: any) {
  function ComponentWithRouterProp(props: any) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

const RouterRender = ({
  router,
  match,
  showTransform,
}: {
  router: any;
  match: any;
  showTransform: any;
}) => {
  // const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

  let { location } = router;
  // const { changeLayout, changeNavType } = useContext(RouterContext);
  const { changeNavType } = useContext(RouterContext);

  useEffect(() => {
    changeNavType(findRouteConfig(location.pathname)?.navType);
  }, [location]);

  return (
    <Suspense fallback={<LoadingView />}>
      <Routes>
        {RouterList.map((route: any, index) => {
          return (
            <Route
              key={index}
              path={route.path}
              element={<route.component {...route.props} />}
            />
          );
        })}
      </Routes>
    </Suspense>
  );
};

const RouterRenderWithRouter = withRouter(RouterRender);

const ProcessRouter = () => {
  const [navType, setNavType] = useState({});

  const actions = {
    changeNavType: (navType = {}) => {
      setNavType(navType ?? {});
    },
  };

  var LayoutComponent = layouts["default"];

  return (
    <RouterContext.Provider value={actions}>
      <AuthContextProvider>
        <ScrollContextProvider>
          <LayoutComponent navType={navType ? navType : { type: "default" }}>
            <RouterRenderWithRouter />
          </LayoutComponent>
        </ScrollContextProvider>
      </AuthContextProvider>
    </RouterContext.Provider>
  );
};

export default ProcessRouter;
